import { useContext, useEffect, useState } from 'react'; 
import styles from './Stores.module.css';
import lineTableItems from '../../assets/line_table_items.svg';
import ArrowBelow from '../../assets/arrow_below.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { StoresContext } from '../../context/StoresContext';
import { getStoresFromDatabase } from '../../hooks/Store';

const Stores = () => {
    const { 
        isCreatedStore, 
        clearSuccess, 
        isDeletedStore, 
        isEditedStore,
        setStore, 
    } = useContext(StoresContext);

    const [stores, setStores] = useState([]);
    const [storeTableLineId, setStoreTableLineId] = useState(null);
    
    const fetchStores = async () => {
        try {
            const response = await getStoresFromDatabase();
            if (response?.data?.stores) {
                setStores(response.data.stores);
            } else {
                console.error("Failed to fetch stores or no stores found.");
            }
        } catch (error) {
            console.error("Error fetching stores:", error);
        }
    };

    useEffect(() => {
        fetchStores();

        if (isCreatedStore !== null) {
            if (isCreatedStore) {
                toast.success("Loja salva com sucesso.");
            } else {
                toast.error("Erro ao salvar a loja.");
            }
            clearSuccess();
        }
    }, [isCreatedStore, clearSuccess]);

 
    useEffect(() => {
        if (isDeletedStore !== null) {
            if (isDeletedStore) {
                toast.success("Loja deletada com sucesso.");
            } else {
                toast.error("Erro ao deletar loja.");
            }
            clearSuccess();
        }
    }, [isDeletedStore, clearSuccess]);

    
    useEffect(() => {
        if (isEditedStore !== null) {
            if (isEditedStore) {
                toast.success("Loja editada com sucesso.");
            } else {
                toast.error("Erro ao editar loja.");
            }
            clearSuccess();
        }
    }, [isEditedStore, clearSuccess]);


    const handleRowClick = ( store ) => {
        setStoreTableLineId(store.id);
        setStore(store);
    };


    return (
        <div className={styles.container}>
            <ToastContainer />
            <div className={styles.infoLine}>
                <img src={ArrowBelow} alt="Seta para baixo" />
                <h4 className={styles.headerInfo}>Tabela de Lojas</h4>
                <img className={styles.line} src={lineTableItems} alt="Linha" />
            </div>

            <div className={styles.tableItems}>
                <table>
                    <thead>
                        <tr>
                            <th><div className={styles.scrollableHeader}>Id</div></th>
                            <th><div className={styles.scrollableHeader}>Nome da loja</div></th>
                            <th><div className={styles.scrollableHeader}>Descrição</div></th>
                            <th><div className={styles.scrollableHeader}>CNPJ</div></th>
                            <th><div className={styles.scrollableHeader}>Telefone</div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {stores.length > 0 ? (
                            stores.map((store) => (
                                <tr 
                                    key={store.id}
                                    onClick={() => handleRowClick( store )}
                                    className={store.id === storeTableLineId ? styles.selectedRow : ''}>
                                    <td>{store.id}</td>
                                    <td>{store.name}</td>
                                    <td>{store.description}</td>
                                    <td>{store.cnpj}</td>
                                    <td>{store.phone}</td>
                                </tr>
                            ))
                        ) : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Stores;
